/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';

export default class DiscussionSkeleton extends Component {
	view() {
		return (
			<div className="DiscussionSkeleton DiscussionListItem">
				<div className="DiscussionListItem-content">
					<a className="DiscussionListItem-author">
						<span className="Avatar"></span>
					</a>

					<a className="DiscussionListItem-main">
						<div className="DiscussionListItem-tags"></div>
						<h3 className="DiscussionListItem-title"></h3>
						<ul className="DiscussionListItem-info"></ul>
					</a>
				</div>
			</div>
		);
	}
}
